import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

import ArrowUpIcon from '../../icons/arrow-up'
import Box from './box'
import FormattedText from './formatted-text'
import Typography from './typography'

export type DetailedListDetail = {
  text: string
  displayArrow?: boolean
  variant?: 'destructive' | 'text-destructive'
}

export type DetailedListProps = {
  icon?: SVGFC
  headers: string[]
  details: DetailedListDetail[]
}

export function DetailedList({ icon: Icon, headers, details }: DetailedListProps) {
  return (
    <Box
      className={
        'bg-white-hover rounded-lg border border-grey-light flex mobile:flex-col items-start gap-2'
      }
    >
      {Icon && <Icon className={'min-w-8 min-h-8 -mt-2 mobile:w-6 mobile:h-6'} />}

      <div className={'flex flex-col gap-2'}>
        {headers.map((header, index) => (
          <Typography variant={'tag'} key={index}>
            {header}
          </Typography>
        ))}

        {details.map((detail, index) => (
          <div className={'flex items-center gap-1'} key={index}>
            {detail.displayArrow && (
              <div className={'bg-secondary-light rounded-full'}>
                <ArrowUpIcon
                  color={tailwindColors.secondary.DEFAULT}
                  className={'w-5 h-5 rotate-90'}
                />
              </div>
            )}

            <FormattedText
              text={detail.text}
              variant={'secondary-body'}
              boldVariant={'tag'}
              className={cn({
                'text-red bg-red-light rounded-lg p-3 !font-bold':
                  detail.variant === 'destructive',
                'text-secondaryRed': detail.variant === 'text-destructive'
              })}
            />
          </div>
        ))}
      </div>
    </Box>
  )
}
